import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { AppointmentDetailsKeys } from "modules/AppointmentDetails/queryKeys";
import { ApiInstance } from "utils/Api";

import type { DeskCommunication } from "models";

export const useCreateDeskCheckinMutation = (appointment_id: number) =>
  useTypedMutation<void, DeskCommunication>({
    mutationFn: async () => (await ApiInstance.post("/receptionists/create", { appointment_id }, ENV.deskBaseURL)).data,
    onSuccess: (_payload, deskCommunication) => {
      const appointment = typedQueryClient.getQueryData(AppointmentDetailsKeys.view);
      if (!appointment) return;

      const deskCommunicationIdx = appointment.desk_communications?.findIndex(dc => dc.id === deskCommunication.id) ?? -1;
      const desk_communications =
        deskCommunicationIdx < 0 || !appointment.desk_communications?.length
          ? [...(appointment.desk_communications ?? []), deskCommunication]
          : appointment.desk_communications.with(deskCommunicationIdx, { ...appointment.desk_communications[deskCommunicationIdx], ...deskCommunication });

      typedQueryClient.setQueryData(AppointmentDetailsKeys.view, { ...appointment, desk_communications });
    }
  });
